/* eslint-disable */
export default {
  rateExceeded:
    'Límite de solicitudes sobrepasado. La aplicación se cerrará en{ttl}segundos.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
